import React from 'react';
import styled from 'styled-components';
import SmallButtonStyled from './Buttons/SmallButtonStyled';

import { FilterTabs, FilterTab } from './Inputs/styles';

const BoardHeaderWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
  height: 50px;
  min-height: 50px;

  &:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 1px;
    background-color: rgba(40, 56, 144, 0.1);
    bottom: 0;
    left: 0;
  }
`;

const BoardHeaderStyled = styled.div`
  position: relative;
  font-family: NunitoSans;
  font-size: 10px;
  font-weight: bold;
  color: #283890;
`;

const SmallRightText = styled.span`
  font-size: 12px;
  opacity: 0.5;
  color: #28283a;
`;

const ButtonGroup = styled.div`
  display: flex;
  & div + div {
    margin-left: 8px;
  }
`;

const Button = ({ button, disabledButton, ...props }) => {
  const disabled = disabledButton || button.disabled;
  const onClick = disabled ? null : button.handler;

  return (
    <SmallButtonStyled {...props} onClick={onClick} disabled={disabled}>
      {button.name}
    </SmallButtonStyled>
  );
};

const BoardHeader = ({
  tabs,
  button,
  buttons,
  children,
  tabIndex,
  rightText,
  setTabIndex,
  disabledButton
}) => (
  <BoardHeaderWrapper>
    {Boolean(tabs?.length) && (
      <FilterTabs value={tabIndex} onChange={setTabIndex}>
        {tabs.map((d) => (
          <FilterTab label={d.name} key={d.value} />
        ))}
      </FilterTabs>
    )}
    <BoardHeaderStyled>{children}</BoardHeaderStyled>
    {Boolean(button) && (
      <SmallButtonStyled onClick={disabledButton ? null : button.handler} disabled={disabledButton}>
        {button.name}
      </SmallButtonStyled>
    )}
    {Boolean(buttons?.length) && (
      <ButtonGroup>
        {buttons.map((button, index) => (
          <Button key={`header-btn-${index}`} button={button} disabledButton={disabledButton} />
        ))}
      </ButtonGroup>
    )}
    {!button && rightText && <SmallRightText>{rightText}</SmallRightText>}
  </BoardHeaderWrapper>
);

const StyledBoardHeader = styled(BoardHeader)``;

export default StyledBoardHeader;
